import { FC, ReactNode } from 'react';
import { Box, Tabs, Tab, TabsProps } from '@mui/material';

interface StyledTabsProps extends Omit<TabsProps, 'children'> {
  tabs: { label: string; value?: number }[];
  children?: ReactNode;
  compact?: boolean;
  align?: 'left' | 'right';
}

const StyledTabs: FC<StyledTabsProps> = ({ tabs, value, onChange, compact, align = 'left', sx, ...props }) => {
  const tabMinHeight = compact ? 28 : 40;
  return (
    <Box
      sx={{
        backgroundColor: '#FFFFFF',
        borderRadius: compact ? '6px' : '8px',
        p: compact ? 0.25 : 0.5,
        display: 'inline-block',
        border: '1px solid',
        borderColor: 'divider',
        ...(align === 'right' ? { ml: 'auto' } : {}),
        ...((sx as object) || {}),
      }}>
      <Tabs
        value={value}
        onChange={onChange}
        sx={{
          minHeight: tabMinHeight,
          '& .MuiTabs-indicator': {
            display: 'none',
          },
          '& .MuiTab-root': {
            textTransform: 'none',
            fontWeight: 500,
            minHeight: tabMinHeight,
            minWidth: compact ? 0 : undefined,
            px: compact ? 1.25 : 3,
            py: compact ? 0.25 : 1.5,
            fontSize: compact ? 12 : undefined,
            borderRadius: compact ? '4px' : '6px',
            backgroundColor: 'transparent',
            color: 'text.secondary',
            textAlign: 'center',
            justifyContent: 'center',
            '&.Mui-selected': {
              backgroundColor: 'primary.main',
              color: 'primary.contrastText',
              fontWeight: 600,
              boxShadow: compact ? 'none' : '0 1px 3px rgba(0,0,0,0.1)',
            },
            '&:hover': {
              backgroundColor: 'rgba(25, 118, 210, 0.08)',
              '&.Mui-selected': {
                backgroundColor: 'primary.dark',
              },
            },
          },
        }}
        {...props}>
        {tabs.map((tab, index) => (
          <Tab key={index} label={tab.label} value={tab.value !== undefined ? tab.value : index} />
        ))}
      </Tabs>
    </Box>
  );
};

export default StyledTabs;

